import React, { useState, useEffect } from 'react';
import moment from 'moment';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from './Button';
import DateSelect from './DateSelect';

import * as api from '../services/api/admin';

function PressEditModal(props) {
  const {
    openEditModal,
    open,
    onClose,
    onDelete,
    classes: { modal, modalContent, input },
  } = props;

  const [id, setId] = useState('');
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [headline, setHeadline] = useState('');
  const [category, setCategory] = useState('');
  const [date, setDate] = useState('');
  const [linkToImg, setLinkToImg] = useState('');
  const [content, setContent] = useState('');
  const [imgDescription, setImgDescription] = useState('');
  const [externalUrl, setExternalUrl] = useState('')

  useEffect(() => {
    (async () => {
      if(openEditModal)
      {
      const press = await api.fetchPressContentById(openEditModal);
      setId(openEditModal)
      setTitle(press.title);
      setAuthor(press.author);
      setHeadline(press.headline);
      setCategory(press.category);
      setDate(press.date);
      setLinkToImg(press.linkToImg);
      setContent(press.content);
      setImgDescription(press.imgDescription);
      setExternalUrl(press.externalUrl)
    }
    })();
  }, [openEditModal]);

  const onUpdate = async obj => {
    try {
      await api.updatePressContent({
        id: openEditModal,
        title,
        author,
        headline,
        category,
        date,
        linkToImg,
        content,
        imgDescription,
        externalUrl,
      });
    } catch (err) {
      console.log(err);
    }
    onClose();
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} >
            <h2>Edit content</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="title"
          value={title}
          className={input}
          onChange={event => setTitle(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Title"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="author"
          value={author}
          className={input}
          onChange={event => setAuthor(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Author"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="headline"
          value={headline}
          className={input}
          onChange={event => setHeadline(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          multiline
          rows="2"
          helperText="Headline"
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="category"
          value={category}
          className={input}
          onChange={event => setCategory(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Category"
        />

        <DateSelect
          label="Date Published"
          disableFuture
          fullWidth
          format="MM/DD/YYYY"
          placeholder="Datw originally publihed MM/DD/YYYY ex. 01/01/2001"
          variant="outlined"
          value={new Date(date)}
          onChange={date => setDate(moment.utc(date).format('MM/DD/YYYY'))}
        />
        <TextField
          variant="outlined"
          fullWidth
          name="linkToImg"
          value={linkToImg}
          className={input}
          onChange={event => setLinkToImg(event.target.value)}
          multiline
          rows="1"
          helperText="Image address URL goes here."
        />
        <TextField
          variant="outlined"
          fullWidth
          name="imgDescription"
          value={imgDescription}
          className={input}
          onChange={event => setImgDescription(event.target.value)}
          multiline
          rows="1"
          helperText="Image imgDescription. Write a short imgDescription."
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="content"
          value={content}
          className={input}
          onChange={event => setContent(event.target.value)}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="4"
          helperText="Content goes here"
        />

        <TextField
          variant="outlined"
          fullWidth
          name="externalUrl"
          value={externalUrl}
          className={input}
          onChange={event => setExternalUrl(event.target.value)}
          multiline
          rows="1"
          helperText="Optional field if there is video, link to article etc."
        />

        <Button
          onClickSuccessSnackbar="Content deleted sucessfully."
          onClickFailSnackbar="Content was not deleted."
          color="secondary"
          onClick={() => onDelete(id)}
        >
          Delete
        </Button>
      </DialogContent>

      <Button
        onClickSuccessSnackbar="You have successfully updated the content."
        onClickFailSnackbar="Content could not be updated."
        color="primary"
        variant="contained"
        justify="center"
        onClick={() =>
          onUpdate({
            title,
            author,
            headline,
            category,
            date,
            linkToImg,
            content,
            imgDescription,
            externalUrl,
          })
        }
      >
        Update
      </Button>
    </Dialog>
  );
}

const styles = () => ({
  modal: { maxWidth: '1000px' },
  modalContent: {
    overflow: 'visible',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(PressEditModal);
